import React, {useEffect, useState} from "react";
import {useLocation} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {IQuery, parseSearch} from "@pg-mono/request";
import {pluralize} from "@pg-mono/string-utils";

import {useRedirectedAuth} from "../../../auth/hooks/use_redirected_auth";
import {useRegistrationFlowRun} from "../../../auth/hooks/use_registration_flow_run";
import {startRegistrationFlowByVariant} from "../../../auth/state/registration_flow_slice";
import {RegistrationWizardAccountEntry} from "../../../auth/types/RegistrationWizardEntry";
import {isRegistrationFlowHostMounted} from "../../../auth/utils/registration_flow_host";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {ViewType} from "../../../view_type/ViewType";
import {IArticleDetailArticle} from "../../actions/IArticleDetail";
import {IArticleCommentStore} from "../../reducers/article_comment_reducer";
import {ArticleContainer} from "../ArticleContainer";
import {ArticleCommentForm} from "./ArticleCommentForm";
import {ArticleCommentList} from "./ArticleCommentList";

interface IProps {
    article: IArticleDetailArticle;
    comments: IArticleCommentStore;
}

const commentLoginRedirectQuery: IQuery = {referer: ViewType.ARTICLE};

export const ArticleComments: React.FC<IProps> = (props) => {
    const {comments} = props;

    const commentsPluralize = pluralize(["Komentarz", "Komentarze", "Komentarzy"]);
    const commentCount = comments.list?.length ?? 0; // required at least one comment to be visible on desktop. On mobile this count is irrelevant, comments are shown unconditionally.

    const location = useLocation();

    const query = parseSearch(location.search);
    // If query contains `referer` param with value `ViewType.ARTICLE` this mean that user was redirected here with oauth flow.
    // In such case we should show comment form.
    const [isFormShown, setIsFormShown] = useState(query.referer === ViewType.ARTICLE || false);

    const dispatch = useAppDispatch();
    const {onRedirectedLogin} = useRedirectedAuth();

    const isAuthenticated = useIsAuthenticated();
    const isRegistrationFlowActive = useAppSelector((state) => state.registrationFlow.isActive);
    const commentRegistrationRun = useRegistrationFlowRun();

    useEffect(() => {
        if (commentRegistrationRun.hasRunFinished && isAuthenticated && !isRegistrationFlowActive) {
            commentRegistrationRun.forgetRun();
            setIsFormShown(true);
        }
    }, [commentRegistrationRun.hasRunFinished, isAuthenticated, isRegistrationFlowActive]);

    const onShowCommentForm = () => {
        if (isAuthenticated) {
            setIsFormShown(true);
            return;
        }

        if (!isRegistrationFlowHostMounted()) {
            void onRedirectedLogin(commentLoginRedirectQuery);
            return;
        }

        dispatch(
            startRegistrationFlowByVariant(
                {
                    isUserLoggedIn: false,
                    userSource: UserSource.COMMENT_ARTICLE,
                    wizardEntry: RegistrationWizardAccountEntry.ARTICLE_COMMENT,
                    amplitudePlacement: null,
                    closeAfterWizard: true
                },
                {type: "km_login", redirectQuery: commentLoginRedirectQuery}
            )
        );
        commentRegistrationRun.rememberStartedRun();
    };

    return (
        <>
            <div className={sectionWrapper}>
                <ArticleContainer>
                    <div className={blogArticleContainer}>
                        <div className={commentDataPanel}>
                            <div>
                                {!!commentCount && (
                                    <Text className={commentCountStyle} variant="headline_6" as="p">
                                        {commentCount} {commentsPluralize(commentCount)}
                                    </Text>
                                )}
                                <Text className={commentInfoText} as="div" variant="body_copy_2">
                                    Komentowanie dostępne tylko dla zalogowanych użytkowników.
                                </Text>
                            </div>

                            {!isFormShown && (
                                <Button className={commentButton} onClick={onShowCommentForm} variant="filled_primary">
                                    skomentuj
                                </Button>
                            )}
                        </div>

                        {isFormShown && <ArticleCommentForm className={commentForm} articleID={props.article.id} />}
                        <ArticleCommentList comments={props.comments.list ?? []} />
                    </div>
                </ArticleContainer>
            </div>
        </>
    );
};

const sectionWrapper = css({
    backgroundColor: "var(--colors-gray-200)",
    pt: 4,
    pb: 4,
    px: 0,
    md: {
        pb: 7
    }
});

const blogArticleContainer = css({
    ml: "auto"
});

const commentDataPanel = css({
    mb: 4,
    md: {
        display: "flex",
        justifyContent: "space-between"
    }
});

const commentCountStyle = css({
    mb: 2
});

const commentInfoText = css({
    color: "var(--colors-gray-700)",
    mb: 2,
    md: {
        mb: 0
    }
});

const commentButton = css({
    width: "100%",
    flexBasis: "100%",
    mb: 5,
    md: {
        width: "unset",
        flexBasis: "unset",
        mb: 0
    }
});

const commentForm = css({
    my: 4,
    mx: 0
});
import React, {useEffect, useState} from "react";
import {useLocation} from "react-router";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {IQuery, parseSearch} from "@pg-mono/request";
import {pluralize} from "@pg-mono/string-utils";

import {useRedirectedAuth} from "../../../auth/hooks/use_redirected_auth";
import {useRegistrationFlowRun} from "../../../auth/hooks/use_registration_flow_run";
import {startRegistrationFlowByVariant} from "../../../auth/state/registration_flow_slice";
import {RegistrationWizardAccountEntry} from "../../../auth/types/RegistrationWizardEntry";
import {isRegistrationFlowHostMounted} from "../../../auth/utils/registration_flow_host";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {ViewType} from "../../../view_type/ViewType";
import {IArticleDetailArticle} from "../../actions/IArticleDetail";
import {IArticleCommentStore} from "../../reducers/article_comment_reducer";
import {ArticleContainer} from "../ArticleContainer";
import {ArticleCommentForm} from "./ArticleCommentForm";
import {ArticleCommentList} from "./ArticleCommentList";

interface IProps {
    article: IArticleDetailArticle;
    comments: IArticleCommentStore;
}

const commentLoginRedirectQuery: IQuery = {referer: ViewType.ARTICLE};

export const ArticleComments: React.FC<IProps> = (props) => {
    const {comments} = props;

    const commentsPluralize = pluralize(["Komentarz", "Komentarze", "Komentarzy"]);
    const commentCount = comments.list?.length ?? 0; // required at least one comment to be visible on desktop. On mobile this count is irrelevant, comments are shown unconditionally.

    const location = useLocation();

    const query = parseSearch(location.search);
    // If query contains `referer` param with value `ViewType.ARTICLE` this mean that user was redirected here with oauth flow.
    // In such case we should show comment form.
    const [isFormShown, setIsFormShown] = useState(query.referer === ViewType.ARTICLE || false);

    const dispatch = useAppDispatch();
    const {onRedirectedLogin} = useRedirectedAuth();

    const isAuthenticated = useIsAuthenticated();
    const isRegistrationFlowActive = useAppSelector((state) => state.registrationFlow.isActive);
    const commentRegistrationRun = useRegistrationFlowRun();

    useEffect(() => {
        if (commentRegistrationRun.hasRunFinished && isAuthenticated && !isRegistrationFlowActive) {
            commentRegistrationRun.forgetRun();
            setIsFormShown(true);
        }
    }, [commentRegistrationRun.hasRunFinished, isAuthenticated, isRegistrationFlowActive]);

    const onShowCommentForm = () => {
        if (isAuthenticated) {
            setIsFormShown(true);
            return;
        }

        if (!isRegistrationFlowHostMounted()) {
            void onRedirectedLogin(commentLoginRedirectQuery);
            return;
        }

        dispatch(
            startRegistrationFlowByVariant(
                {
                    isUserLoggedIn: false,
                    userSource: UserSource.COMMENT_ARTICLE,
                    wizardEntry: RegistrationWizardAccountEntry.ARTICLE_COMMENT,
                    amplitudePlacement: null,
                    closeAfterWizard: true
                },
                {type: "km_login", redirectQuery: commentLoginRedirectQuery}
            )
        );
        commentRegistrationRun.rememberStartedRun();
    };

    return (
        <>
            <div className={sectionWrapper}>
                <ArticleContainer>
                    <div className={blogArticleContainer}>
                        <div className={commentDataPanel}>
                            <div>
                                {!!commentCount && (
                                    <Text className={commentCountStyle} variant="headline_6" as="p">
                                        {commentCount} {commentsPluralize(commentCount)}
                                    </Text>
                                )}
                                <Text className={commentInfoText} as="div" variant="body_copy_2">
                                    Komentowanie dostępne tylko dla zalogowanych użytkowników.
                                </Text>
                            </div>

                            {!isFormShown && (
                                <Button className={commentButton} onClick={onShowCommentForm} variant="filled_primary">
                                    skomentuj
                                </Button>
                            )}
                        </div>

                        {isFormShown && <ArticleCommentForm className={commentForm} articleID={props.article.id} />}
                        <ArticleCommentList comments={props.comments.list ?? []} />
                    </div>
                </ArticleContainer>
            </div>
        </>
    );
};

const sectionWrapper = css({
    backgroundColor: "var(--colors-gray-200)",
    pt: 4,
    pb: 4,
    px: 0,
    md: {
        pb: 7
    }
});

const blogArticleContainer = css({
    ml: "auto"
});

const commentDataPanel = css({
    mb: 4,
    md: {
        display: "flex",
        justifyContent: "space-between"
    }
});

const commentCountStyle = css({
    mb: 2
});

const commentInfoText = css({
    color: "var(--colors-gray-700)",
    mb: 2,
    md: {
        mb: 0
    }
});

const commentButton = css({
    width: "100%",
    flexBasis: "100%",
    mb: 5,
    md: {
        width: "unset",
        flexBasis: "unset",
        mb: 0
    }
});

const commentForm = css({
    my: 4,
    mx: 0
});
